let currentSlide = null;
let swipeStart = null;
let swipeEnd = null;
let popupList = null;
let currentNameData = null;

window.dremVars = {};

window.k1Base = {
	setMaxHeightGeneral: function (className) {
		let elements = document.querySelectorAll(className);
		let tmpArr = [...elements];
		let maxHeight = 0;
		let marginTop, marginBottom, total, marginTopNextElem;
		if (tmpArr) {
			tmpArr.forEach(elem => {
				maxHeight = 0;
				marginTop = 0;
				marginTopNextElem = 0;
				marginBottom = 0;
				total = 0;
				[...elem.children].forEach(child => {
					maxHeight += child.clientHeight;
				});
				elem.setAttribute('data-max-height', maxHeight);
				return false;
			});

			return false;
		}

		// k1-toggle-box-js
	},
	fillFilter: function () {
		let checkboxes = document.querySelectorAll('.articles-list__filter-items .checkbox');
		checkboxes.forEach(elem => {
			let input = elem.querySelector('input');
			if (input.checked == true) {
				elem.classList.add('select')
			} else {
				elem.classList.remove('select')
			}
		})
	},
	init: function () {
		this.setMaxHeightGeneral('.k1-toggle-box-js')
	}
};

function makeModal() {
	let modal = `<div class="k1-modal k1-modal__bg">
					<div class="k1-modal__body k1-modal-popup-slider">
					<div class="k1-modal__close"></div>
					<div class="k1-modal__arrow k1-modal__prev"></div>
					<div class="k1-modal__arrow k1-modal__next"></div>
					<div class="k1-modal-popup-slider__picture">
					<img src="" alt="">
					</div>
					<div class="k1-modal-dots" style="display: none">
					</div>
				</div>`
	document.querySelector('footer').insertAdjacentHTML('afterend', modal)
}

function initPopup() {
	makeModal();
}

function openModal() {
	document.querySelector('body').style.overflow = 'hidden';
	document.querySelector('.k1-modal').style.display = 'flex';
}

function closeModal(event) {
	const target = event.target;
	if (target.closest('.modal-fast-buy')) {
		if (target.closest('.k1-modal__close')) {
			let modal = target.closest('.modal');
			document.querySelector('body').style.overflow = 'auto';
			modal.style.display = 'none';
		}

		return;
	}

	if (target.closest('.success-review-modal')) {
		if (target.closest('.k1-modal__close')) {
			let modal = target.closest('.modal');
			window.k1ScriptComments.hideSuccessModal();
			document.querySelector('body').style.overflow = 'auto';
			modal.style.display = 'none';
		}

		return;
	}
	if (target.closest('.success-callback-modal')) {
		if (target.closest('.k1-modal__close')) {
			let modal = target.closest('.modal');
			window.k1ScriptComments.hideSuccessModal();
			document.querySelector('body').style.overflow = 'auto';
			modal.style.display = 'none';
		}

		return;
	}


}

function sortSearchResult(event) {
	let target = event.target;
	if (!target.classList.contains('k1-search-form__section') || !target.closest('.k1-show-result')) return false;
	target.classList.toggle('chosen');
	let sectionList = document.querySelectorAll('.k1-search-form__section');
	let itemList = document.querySelectorAll('.k1-search-form__list-item');

	let test = [...sectionList].filter(section => {
		if (section.classList.contains('chosen')) {
			return section.getAttribute('data-search-section')
		}
	})

	let sectionNames = [];

	sectionList.forEach(item => {
		if (item.classList.contains('chosen')) {
			sectionNames.push(item.getAttribute('data-search-section'))
		}
	})
	itemList.forEach(item => {
		if (sectionNames.length) {
			if (sectionNames.includes(item.getAttribute('data-search-section-item'))) {
				item.style.display = 'block'
			} else {
				item.style.display = 'none'
			}
		} else {
			item.style.display = 'block'
		}

	})
}

window.addEventListener('DOMContentLoaded', function () {
	let pictures = document.querySelectorAll('.def-load-picture');
	window.k1ScriptDefault.loadPictures([...pictures]);

	if (document.querySelector('.good-element')) {
		window.k1ScriptCatalog.prepareSKU([...document.querySelectorAll('.k1-sku-block-js')]);
		window.k1ScriptDefault.loadPictures([...document.querySelectorAll('.def-load-picture')]);
		window.k1Sliders.init();
	}

	if (document.querySelector('.section-goods')) {
		window.k1ScriptCatalog.prepareSKU([...document.querySelectorAll('.k1-sku-block-js')]);
		window.k1ScriptDefault.loadPictures([...document.querySelectorAll('.def-load-picture')]);
		window.k1ScriptCatalog.setLastChild();
	}

	window.k1Base.init();
	initPopup();
});

// new Burger
function openBurger(event) {
	const target = event.target;
	target.closest('.burger').classList.toggle('open');
	target.closest('.burger').setAttribute('aria-expanded', target.closest('.burger').classList.contains('open'));

	if (target.closest('.burger').classList.contains('open')) {
		document.querySelector('.header').classList.add('burger-open');
		document.querySelector('.footer').classList.add('burger-open');
		document.querySelector('.header__main-menu').classList.add('open');
		document.body.style.overflow = 'hidden';
		document.querySelector('main').classList.add('open-burger');
	} else {
		document.querySelector('.header').classList.remove('burger-open');
		document.querySelector('.footer').classList.remove('burger-open');
		document.querySelector('.header__main-menu').classList.remove('open');
		document.querySelector('.header-mobile').classList.remove('open');
		document.body.style.overflow = 'auto';
		document.querySelector('main').classList.remove('open-burger');


	}
}

function wayPays(type){

	if ( ! document.querySelector('.way-pay__left')) return;
	let left = document.querySelector('.way-pay__left');
	let mobile = document.createElement('div');


	if( !document.querySelector('.way-pay__mobile')){
		mobile.className = 'way-pay__mobile';
	}else{
		mobile = document.querySelector('.way-pay__mobile');
	}

	if(type == true){
		left.append(mobile);
		let wayPays = document.querySelectorAll('.way-pay__row-item');
		wayPays.forEach(function(wayPayItem){
			wayPayItem.classList.add('way-pay__v1-js')
		});

	}else{
		mobile.remove();
		let wayPays = document.querySelectorAll('.way-pay__row-item');
		wayPays.forEach(function(wayPayItem){
			wayPayItem.classList.remove('way-pay__v1-js')
		});
	}

}

function compositionMobile(type){
	if ( ! document.querySelector('.element-composition')) return;
	let composition = document.querySelector('.element-composition');

	if(type)
		composition.classList.add('mobile');
	else
		composition.classList.remove('mobile');
}

function statsMobile(type){
	if ( ! document.querySelector('.element-main__stats')) return;
	let stats = document.querySelector('.element-main__stats');

	if(type)
		stats.classList.add('mobile');
	else
		stats.classList.remove('mobile');
}

function asideInfo(type){
	if ( ! document.querySelectorAll('.element-aside__block')) return;
	let info = document.querySelectorAll('.element-aside__block');

	if(type){
		for (var i = 0; i < info.length; ++i) {
			info[i].classList.add('mobile');
		}
	}
	else{
		for (var i = 0; i < info.length; ++i) {
			info[i].classList.remove('mobile');
		}
	}

}

function social(type){
	if ( ! document.querySelector('.element-social')) return;
	let social = document.querySelector('.element-social');

	if(type)
		social.classList.add('mobile');
	else
		social.classList.remove('mobile');
}

function reviewsMobile(type){
	if ( ! document.querySelector('.element-main__reviews ')) return;
	let reviews = document.querySelector('.element-main__reviews ');

	if(type)
		reviews.classList.add('mobile');
	else
		reviews.classList.remove('mobile');
}

function CardDetailMobile(type){
	var cardMobile;

	if(type ){
		if( !document.querySelector('.mobile-slider.swiper-container-initialized'))
			cardMobile = new Swiper('.mobile-slider', {
				slidesPerView: 1,
				spaceBetween: 15,
				centeredSlides: true,
				roundLengths: true,
				loop: true,
				loopAdditionalSlides: 30,
				pagination: {
					el: '.mobile-slider__slider-pagination',
					clickable: true
				},
			});

	}else{
		if(document.querySelector('.mobile-slider.swiper-container-initialized')){
			if (cardMobile){
				cardMobile.destroy(true, true );
			}
			cardMobile = undefined;
		}
	}

}

function concomitantMove(type){
	let concomitant = document.querySelector('.good-element__concomitant');
	// let prev = concomitant.previousElementSibling;
	let afterMove = document.querySelector('.good-element__sku')
	let beforeMove = document.querySelector('.good-element__buttons')

	if( concomitant)
		if ( type ) {
			// if ( prev != afterMove)
				afterMove.after(concomitant);
		} else {
			// if ( prev != beforeMove)
				beforeMove.after(concomitant);
		}
}

function SearchMobile(){
	let seachMobile  = document.querySelector('.header__seach-mobile form');

	if( window.innerWidth < 360 )
		seachMobile.style.width = window.innerWidth - 110 + 'px';
	else
		seachMobile.style.width = window.innerWidth - 130 + 'px';
}

// add function for mobile menu
var mobileWidth = window.innerWidth;
function mobileInit(e) {
	// console.log('mobileInit : ',e );
	mobileWidth = window.innerWidth;

	const mobileMenu = document.querySelector('.header__main-menu .container');
	const headerRow = document.querySelector('.header__row');
	const headerLogo = document.querySelector('.header__logo');
	const headerTop = document.querySelector('.header__top');
	const headerTopLeft = document.querySelector('.header__top-left');
	const headerTopRight = document.querySelector('.header__top-right');
	const headerSearch = document.querySelector('.header__seach');
	const headerPhone = document.querySelector('.header__phone');
	const headerPhoneClone = headerPhone.cloneNode(true);

	const headerToolsLeft = document.querySelector('.header__tools-items.append-left');
	const headerToolsRight = document.querySelector('header__tools-items.append-right');

	const footerWrap = document.querySelector('.footer__right');
	const footerContact = document.querySelector('.footer__contact');
	const footerSocial = document.querySelector('.footer__social');
	const footerMarket = document.querySelector('.footer__market');
	const footerColumns = footerWrap.querySelectorAll('.footer__colum');
	const footerMobileTop = document.querySelector('.footer__mobile-top');
	const footerMobileBottom = document.querySelector('.footer__mobile-bottom');
	const footerColumnList = Array.from(footerColumns);

	const dropColumns = document.querySelectorAll('.drop-header__link');
	const dropHeader = Array.from(dropColumns);

	// * Sale Up
	const saleupRight = document.querySelector('.sale-up__right');
	const saleupLeft = document.querySelector('.sale-up__left');
	const saleupButton = document.querySelector('.sale-up__button');



	if (document.querySelector('.header__tools-basket-drop-block')) {
		if (e <= 520) {
			let width = e - 30;
			document.querySelector('.header__tools-basket-drop-block').style.width = width + "px";
		} else {
			document.querySelector('.header__tools-basket-drop-block').style.width = '';
		}
	}

	if (e <= 1199) {
		footerMobileTop.append(footerContact);
		footerMobileBottom.append(footerSocial);
		if (footerMarket)
			footerMobileBottom.append(footerMarket);
	}

	if (e <= 991) {
		mobileMenu.append(headerTopRight);
		mobileMenu.append(headerTopLeft);
		headerTopRight.append(document.querySelector('.menu-stocks.drop-left'));
		document.querySelectorAll('.header__tools-img.like').forEach(function (elem) {
			headerTopRight.append(elem.parentNode);
		});

		headerTopLeft.append(document.querySelector('.masseng.drop-right'));
		document.querySelector('.masseng.drop-right img').src = "/custom/img/icons/svg/menu-contact.svg"
		headerTopLeft.append(document.querySelector('.car.drop-right'));
		document.querySelector('.car.drop-right').style.display = "none";
		headerTopLeft.append(document.querySelector('.price.drop-right'));
		document.querySelector('.price.drop-right img').src = "/custom/img/icons/svg/menu-installment.svg"
		// mobileMenu.prepend(headerSearch);
		mobileMenu.prepend(headerPhone);
		footerColumnList.forEach(function (elem) {
			let footerMenuList = Array.from(elem.querySelectorAll('.footer__menu'));
			let footerSubTitle = elem.querySelector('.footer__subtitle');
			if (!elem.querySelector('.footer__subtitle-before')) {
				let footerSubTitleBefore = document.createElement('div');
				footerSubTitleBefore.classList.add('footer__subtitle-before');
				footerSubTitle.insertAdjacentElement('beforeEnd', footerSubTitleBefore);
			}

			elem.addEventListener('click', function () {
				elem.querySelector('.footer__subtitle-before').classList.toggle('footer__subtitle-before--toggle');
				footerMenuList.forEach(function (e) {
					e.classList.toggle('footer__menu--visible');
				});
			});

		});
		saleupLeft.append(saleupButton);


		if( !document.querySelector('.header-mobile .header__phone')){
			document.querySelector('.header-mobile .container').append(headerPhoneClone);
		}
		document.querySelector('.header__top-link.price.drop-right').innerHTML ='<img src="/custom/img/icons/svg/menu-installment.svg" alt="Рассрочка "> Рассрочка';

		// * Padding main top
		let bredrams = document.querySelector('.breadcrumbs');
		if (bredrams){
			document.querySelector('.main').style.paddingTop = document.querySelector('.header').offsetHeight + bredrams.clientHeight - 20 + 'px';
		} else{
			document.querySelector('.main').style.paddingTop = document.querySelector('.header').offsetHeight - 10 + 'px';
		}
	}

	if (e <= 767) {
		mobileMenu.prepend(headerSearch);
		mobileMenu.prepend(headerPhone);
		wayPays(true);
		compositionMobile(true);
		statsMobile(true);
		asideInfo(true);
		social(true);
		reviewsMobile(true);
		CardDetailMobile(true);
		SearchMobile();
		concomitantMove(true);

	}

	if (e > 767) {
		headerLogo.insertAdjacentElement('afterEnd', headerSearch);
		wayPays(false);
		compositionMobile(false);
		statsMobile(false);
		asideInfo(false);
		social(false);
		reviewsMobile(false);
		CardDetailMobile(false);
		concomitantMove(false);

	}

	if (e > 991) {
		document.querySelector('.main').style.paddingTop = '0';

		headerTop.prepend(headerTopRight);
		headerTop.prepend(headerTopLeft);
		if (document.querySelector('.header__tools-items.append-right') && document.querySelector('.header__tools-items.append-right').closest('.header__top-right')) {
			document.querySelector('.header__tools').prepend(document.querySelector('.header__tools-items.append-right'));
		}
		if (document.querySelector('.header__tools-items.append-left') && document.querySelector('.header__tools-items.append-left').closest('.header__top-right')) {
			document.querySelector('.header__tools').prepend(document.querySelector('.header__tools-items.append-left'));
		}

		document.querySelectorAll('.drop-left').forEach(function (elem) {
			headerTopLeft.append(elem);
		});
		document.querySelectorAll('.drop-right').forEach(function (elem) {
			headerTopRight.append(elem);
		});

		document.querySelector('.masseng.drop-right img').src = "/custom/img/icons/svg/masseng.svg"
		document.querySelector('.car.drop-right').style.display = "block";
		document.querySelector('.price.drop-right img').src = "/custom/img/icons/svg/price.svg"
		headerLogo.insertAdjacentElement('afterEnd', headerPhone)
		headerPhone.insertAdjacentElement('afterEnd', headerSearch)

		saleupRight.append(saleupButton);
	}

	if (e > 1199) {
		document.querySelector('.footer__left').append(footerContact);
		document.querySelector('.footer__left').append(footerSocial);
		if (footerMarket)
			document.querySelector('.footer__left').append(footerMarket);
	}

};

window.addEventListener('resize', (e) => {
	if(mobileWidth != window.innerWidth)
		mobileInit(window.innerWidth);
})

mobileInit(window.innerWidth);

window.matchMedia("(orientation: portrait)").addListener(function(m) {
	mobileInit(window.innerWidth);
	if ( (767 < window.innerWidth && 767 < window.innerHeight ) || window.innerWidth > 991) window.location.reload()
});

// end function for mobile menu and footer
window.addEventListener('click', function (e) {
	if (e.target.closest('.checkbox') && e.target.closest('.articles-list__filter-items')) {
		window.k1Base.fillFilter()
	}
	if (e.target.closest('.burger'))
		openBurger(e);

	sortSearchResult(e);
	closeModal(e);

});

// ! Cookie set empty
document.addEventListener('DOMContentLoaded', function (){
	if (!window.k1Cookies.getCookie('k1FavoriteGoods'))
		window.k1Cookies.setCookie('k1FavoriteGoods', '{}', { path: '/', expires: new Date() + 3600*24 });

	if (!window.k1Cookies.getCookie('k1CompareGoods'))
		window.k1Cookies.setCookie('k1CompareGoods', '[]', { path: '/', expires: new Date() + 3600 * 24 });
});
